import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentPost } from '../../../../store/actions/contentActions';
import { hasVideo, navigateToContent, openLink, renderSubTitleSearch } from '../../Globals/globals';
import avatar from './../../../../assets/images/avatar.png';
import './SearchItem.scss';
import { SearchItemProps } from './SearchItemProps';
import { useNavigate,useLocation } from 'react-router-dom'

export const SearchItem = (props: SearchItemProps) => {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { item } = props;


    const goToCommunityPage = (id: string) => {
        navigate('/community/' + id)
    }    

    const renderUserName = (item: any, who?: string) => {
        switch (who) {
            case "content_creator":
                return item?.content && item?.content.createdByUser ? (<span>by <span className="highlight">{item?.content.createdByUser.firstName + ' ' + item?.content.createdByUser.lastName}</span></span>) : null
            default:
                return item?.user && item?.user[0] ? (<span>by <span className="highlight">{item?.user[0].firstName + ' ' + item?.user[0].lastName}</span></span>) : null
        }
    }

    const renderLinkData = (item: any) => {
        let linkData;
        if (item.content.type === 'external_link') {
            linkData = <Fragment>
                <div className=" px-3 pb-3" onClick={(e) => { openLink(item.content.media[0]?.link, e) }}>
                    <div className="si-content row m-0 p-0">
                        <div className="col-md-9 col-12 d-flex flex-column align-items-start justify-content-center">
                            <p className="m-0 content-link">
                                {item.content?.media[0]?.link}
                            </p>
                            <p className="m-0 content-title">
                                {item.content?.title}
                            </p>
                        </div>
                        <div className="col-md-3 col-12 m-0 p-0 d-flex justify-content-md-end align-items-center justify-content-start">
                            <div className="search-item-link-photo">
                                <img src={item?.content?.thumbnail} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        } else if (item.content.type === 'file') {
            linkData = <Fragment>
                <div className=" px-3 pb-3">
                    <div className="si-content row m-0 p-0">
                        <div className="col-9 d-flex flex-column align-items-start justify-content-center">
                            <p className="m-0 note">
                                {item.content?.description}
                            </p>
                        </div>
                        {/* {state?.thumbnail ? <div className="col-3 m-0 p-0 d-flex justify-content-end align-items-center ">
                            <div className="search-item-link-photo">
                                <img src={state?.thumbnail} alt="" />
                            </div>
                        </div> : null} */}
                    </div>
                </div>
            </Fragment>
        }
        return linkData;
    }


    const renderTitle = () => {
        let title;
        if (item.content) {
            if (item.content.type === 'sefaria_link') {
                title = <div>New Source Sheet {renderUserName(item)}</div>
            }
            else if (item.content.type === 'file') {
                title = <div className="bold-title">{item.content?.title}</div>
            }
            else if (item.content.type === 'hartman_link') {
                title = <div className="bold-title">{item.content?.title}</div>
            }
            else if (item.content.type === 'session_recording') {
                title = <div> Shared Session Recording Link {renderUserName(item)}</div>
            }
            else if (item.content.type === 'quick_post') {
                title = <div> New Post {renderUserName(item)}</div>
            }
            if (hasVideo(item)) {
                title = <div className="bold-title">{item.content?.title}</div>
            } else if (item.content.type === 'external_link') {
                title = <div> Shared by {renderUserName(item)}</div>
            }
        }
        return title;
    }

    const renderPostContent = (item: any) => {
        let post;
        if (item?.post) {
            post = <div className="note my-3">
                {item.post}
            </div>
        }
        return post;
    }

    const renderUserAvatar = (item: any) => {
        return <img className="user-photo" src={item?.content?.createdByUser?.image ? item?.content?.createdByUser?.image : avatar} alt="publish user" />
    }

    return <div className="search-item" onClick={() => navigateToContent(item, navigate, () => {
        dispatch(setCurrentPost(item))
    })}>
        <div className="wrapper" >
            <div className="details-row p-3 flex-md-wrap">
                {renderUserAvatar(item)}
                <div className="summary">
                    <div className="title">
                        {renderTitle()}
                    </div>
                    <div className="note">
                        {renderSubTitleSearch(item, goToCommunityPage)}
                    </div>
                    {renderPostContent(item)}
                </div>
            </div>
            {renderLinkData(item)}
        </div>
    </div>
}